import { create } from "apisauce";
import { API_TIMEOUT } from "constants/api";


const API_LOGIN = create({
  baseURL: window.endPoint,
  timeout: API_TIMEOUT,
});

const API = create({
  baseURL: window.endPoint,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const API_AUTH = create({
  baseURL: window.endPoint,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const API_AUTH_API = create({
  baseURL: window.endPointApi,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const API_AUTHDEMO = create({
  baseURL: window.endPointUrlDemo,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const API_AUTHNEW = create({
  baseURL: window.endPointNew,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const API_AUTHBACKUP = create({
  baseURL: window.endPointBackup,
  timeout: 60000,
  headers: { Accept: "application/octet-stream" },
});

// Hàm thiết lập token và URL cho API_AUTH
function setTokenGlobal(token, url) {
  API_AUTH.setHeader("Authorization", token);
  if (url && typeof url !== "undefined") {
    API_AUTH.setBaseURL(url);
  }
}

// Hàm thiết lập token và URL cho API_AUTHNEW
function setTokenForNewAPI(token, url) {
  API_AUTHNEW.setHeader("Authorization", token);
  if (url && typeof url !== "undefined") {
    API_AUTHNEW.setBaseURL(url);
  }
}
//
// Hàm thiết lập token và URL cho API_AUTHNEW
function setTokenForAUTHDEMO(token, url) {
  API_AUTHDEMO.setHeader("Authorization", token);
  if (url && typeof url !== "undefined") {
    API_AUTHDEMO.setBaseURL(url);
  }
}
function setTokenForBackupAPI(token, url) {
  API_AUTHBACKUP.setHeader("Authorization", token);
  if (url && typeof url !== "undefined") {
    API_AUTHBACKUP.setBaseURL(url);
  }
}

// Export các API và hàm
export {
  API_LOGIN,
  API,
  API_AUTH,
  API_AUTHNEW,
  API_AUTHDEMO,
  API_AUTHBACKUP,
  API_AUTH_API,
  setTokenGlobal,
  setTokenForNewAPI,
  setTokenForBackupAPI,
  setTokenForAUTHDEMO
};
